import { isEmpty } from 'lodash'

import { BACKEND_FILTER_IDS, FRONTEND_FILTER_NAMES_BY_ID } from '@/utils/okr-custom-filters'
import { FILTERS_KEYS } from '@/utils/okr-elements/filters'

export const FEED_CUSTOM_FILTERS_KEYS = {
  USERS: BACKEND_FILTER_IDS[FILTERS_KEYS.ASSIGNEE_IDS],
  GROUPS: BACKEND_FILTER_IDS[FILTERS_KEYS.GROUP_IDS]
}

export const createPayloadForFeedCustomFilter = (filterData = {}) =>
  Object.values(FEED_CUSTOM_FILTERS_KEYS).reduce((acc, key) => {
    const filterValue = key in filterData ? filterData[key] : null

    acc[key] = JSON.stringify(filterValue)
    return acc
  }, {})

export const parseSavedFilterValues = ({
  filterData = {},
  replaceFilterIdWithFilterKey = true
} = {}) => {
  const { filters = {} } = filterData

  const safeParse = value => {
    try {
      return JSON.parse(value)
    } catch {
      return null
    }
  }

  return Object.entries(filters).reduce((acc, [key, value]) => {
    const parsed = safeParse(value)

    const resolvedKey = (replaceFilterIdWithFilterKey && FRONTEND_FILTER_NAMES_BY_ID[key]) || key

    acc[resolvedKey] = isEmpty(parsed) ? null : parsed

    return acc
  }, {})
}
